import React, { useEffect, useState } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom';
import ScrollToTop from '../ScrollToTop';
import Select from './templates/select/Select';
import Upload from './templates/upload/Upload';
import Preview from './templates/preview/Preview';
import { useTranslation } from 'react-i18next';
import CompanyForm from './company/form/Form'
import CompanyPreview from './company/preview/Preview';
import SetUpComplete from './complete/SetUpComplete';
import Header from './Header';
import axios from 'axios';
import { useMsal, useAccount } from '@azure/msal-react';
import { silentRequest } from '../../authConfig';
const API_URL = process.env.REACT_APP_API_URL;


const Boarding = ({ accountData, companyDetailData }) => {

  const { t, i18n } = useTranslation();
  const [currentStep, setCurrentStep] = useState(1);
  const isAllowed = (requiredStep) => currentStep >= requiredStep;

  const [nameHeaderLabel, setNameHeaderLabel] = useState(t('boarding.pleaseSelectDocumentTemplates'))
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  useEffect(() => {
    if (currentStep >= 1 && currentStep <= 3) {
      setNameHeaderLabel(t('boarding.pleaseSelectDocumentTemplates'));
    } else if (currentStep === 4 || currentStep === 5) {
      setNameHeaderLabel(t('boarding.pleaseFillCompanyData'));
    } else if (currentStep >= 6) {
      setNameHeaderLabel(t('boarding.setupComplete'));
    }
    // eslint-disable-next-line
  }, [currentStep, i18n.language]);

  const [companyIdDetect,setCompanyIdDetect]= useState('')

    useEffect(() => {
    const handlePopState = () => {
      if (companyIdDetect !== '') {
        console.log('User tried to go back after save. Refreshing...');
        window.location.reload(); 
      }
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
    }, [companyIdDetect]);


  const handleUpdate = async (replace, currentValue, activeFrom) => {
    try {
      const tokenResponse = await instance.acquireTokenSilent({
        ...silentRequest,
        account: account
      });

      console.log('boarding oid check ',tokenResponse);
      console.log('tokenResponse find oid', tokenResponse.idTokenClaims.oid);
      

      const response = await axios.patch(`${API_URL}/accounts`, {
         replace: replace,
         value: currentValue
      }, {
        headers: {
          Authorization: 'Bearer ' + tokenResponse.accessToken,
          'Content-Type': 'application/json',
          oid: tokenResponse.idTokenClaims.oid
        }
      });

      // const response = await axios.patch(`http://localhost:7071/api/accounts`, {
      //   replace: replace,
      //   value: currentValue
      // }, {
      //   headers: {
      //     Authorization: 'Bearer ' + tokenResponse.accessToken,
      //     'Content-Type': 'application/json',
      //     oid: tokenResponse.idTokenClaims.oid
      //   }
      // });
      
      console.log('Update success:', response.data);
    } catch (error) {
      console.log('active fail from file', activeFrom);
      console.error('Update failed:', error);
    }
  };
    


  const initializeBoardingData = {
    lastestStep: 1,
    lastestSubStep: 1,
    uploadLogo: false,
    uploadSignature: false,
    imageCheckbox: false,
    templatePreviewButtonClick: false,
    companySearch: false,
    companySearchFound:false,
    companySearchTaxid:'',
    companySearchBranchNumber:'',
    companyPreviewButtonClick: false
  };

  useEffect(() => {
    const initBoardingIfNotExists = async () => {
      try {

        console.log('account data', accountData);
        
        if (!accountData.boarding || Object.keys(accountData.boarding).length === 0) {
          console.log(' Boarding log data not in DB → create init data');
          await handleUpdate('/boarding', initializeBoardingData);
        } else {
          console.log(' Boarding already exist !');
        }

      } catch (error) {
        console.error('Failed to check or initialize boarding:', error);
      }
    };

    initBoardingIfNotExists();
    // eslint-disable-next-line
  }, []);
    


    

  const Pages = () => {
    return (
      <>
       
        <Switch>
          <Route exact path='/boarding/templates/select'>
            <ScrollToTop />
            <Select
              setCurrentStep={setCurrentStep}
              handleUpdate={handleUpdate}
            />
          </Route>
          <Route exact path='/boarding/templates/upload'>
            {isAllowed(2)  ? (
              <>
                <ScrollToTop />
                <Upload
                  setCurrentStep={setCurrentStep}
                  handleUpdate={handleUpdate}
                />
              </>
            ) : (
              <Redirect to='/boarding/templates/select' />
            )}
          </Route>
          <Route exact path='/boarding/templates/preview'>
            {isAllowed(3) ? (
              <>
                <ScrollToTop />
                <Preview
                  setCurrentStep={setCurrentStep}
                  handleUpdate={handleUpdate}
                />

              </>
            ) : (
              <Redirect to='/boarding/templates/select' />
            )}
          </Route>
          <Route exact path='/boarding/company/form'>
            <>
              <ScrollToTop />
              <CompanyForm
                setCurrentStep={setCurrentStep}
                handleUpdate={handleUpdate}
              />
            </>

          </Route>
          <Route exact path='/boarding/company/preview'>
            {isAllowed(5)  ? (
              <>
                <ScrollToTop />
                <CompanyPreview setCurrentStep={setCurrentStep} setCompanyIdDetect={setCompanyIdDetect} handleUpdate={handleUpdate} />
              </>
            ) : (
              <Redirect to='/boarding/templates/select' />
            )}
          </Route>
          <Route exact path='/boarding/complete'>
            {isAllowed(6) ? (
              <>
                <ScrollToTop />
                <SetUpComplete />
              </>
            ) : (
              <Redirect to='/boarding/templates/select' />
            )}
          </Route>

          <Redirect to='/boarding/templates/select' />

        </Switch>
      </>
    )
  }

  return (
    <>
    <Header  {...{ accountData: accountData, companyData: { name: nameHeaderLabel }, companyDetailData: companyDetailData }} />
    <Pages />
    </>
  )
}

export default Boarding